import script from "./Joining.vue?vue&type=script&setup=true&lang=ts"
export * from "./Joining.vue?vue&type=script&setup=true&lang=ts"

import "./Joining.vue?vue&type=style&index=0&id=a025b4e0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a025b4e0"]])

export default __exports__